
import { lazy } from 'react';
import ReferralPage from '../pages/referral/page';

// Lazy load components
const SplashPage = lazy(() => import('../pages/splash/page'));
const HomePage = lazy(() => import('../pages/home/page'));
const OnboardingPage = lazy(() => import('../pages/onboarding/page'));
const LoginPage = lazy(() => import('../pages/auth/login/page'));
const RegisterPage = lazy(() => import('../pages/auth/register/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));

const routes = [
  {
    path: '/splash',
    element: <SplashPage />
  },
  {
    path: '/',
    element: <HomePage />
  },
  {
    path: '/referral',
    element: <ReferralPage />,
  },
  {
    path: '/onboarding',
    element: <OnboardingPage />
  },
  {
    path: '/auth/login',
    element: <LoginPage />
  },
  {
    path: '/auth/register',
    element: <RegisterPage />
  },
  {
    path: '*',
    element: <NotFoundPage />
  }
];

export default routes;
